import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
var SubscribeButton = function (_a) {
    var tier = _a.tier, _b = _a.tier.tier, _c = _b === void 0 ? {} : _b, dollarPrice = _c.dollarPrice, isUserSubscribed = _c.isUserSubscribed, canUserSubscribe = _c.canUserSubscribe, _d = _a.withPrice, withPrice = _d === void 0 ? false : _d, className = _a.className, href = _a.href, onClick = _a.onClick;
    var t = useTranslation().t;
    var clickHandler = useCallback(function () { return onClick && onClick(tier); }, [onClick, tier]);
    // TODO: this (or the ds button itself) really needs a focus-visible ring
    if (!canUserSubscribe) {
        return (React.createElement(SolidButton, { className: className, size: "medium", variant: "main", priority: "primary", disabled: true }, t('deviation.tier.noSubscribing')));
    }
    if (isUserSubscribed) {
        return (React.createElement(GhostButton, { className: className, size: "medium", variant: "main", href: href, onClick: onClick }, t('deviation.tier.unsubscribe')));
    }
    var showPrice = withPrice && dollarPrice;
    return (React.createElement(BrandedButton, { className: className, size: "medium", variant: "brand-green", href: href, onClick: clickHandler }, showPrice
        ? t('deviation.tier.subscribeWithPrice', {
            dollarPrice: dollarPrice,
        })
        : t('deviation.tier.subscribe')));
};
SubscribeButton.displayName = 'SubscribeButton';
export default SubscribeButton;
//# sourceMappingURL=SubscribeButton.js.map